var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBinfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9997 21.6667H21.6663V13.6667H22.9997V11L21.6663 4.33337H1.66634L0.333008 11V13.6667H1.66634V21.6667H13.6663V13.6667H18.9997V21.6667ZM10.9997 19H4.33301V13.6667H10.9997V19ZM1.66634 0.333374H21.6663V3.00004H1.66634V0.333374Z",
    fill: "#E66100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinfo);
export default __webpack_public_path__ + "static/media/binfo.fca084ab3d38d5e8ac1edcab744a49d5.svg";
export { ForwardRef as ReactComponent };